(function () {
    'use strict';
    angular.module('AngularAdmin')
        .factory('OrderSvc', ['$http', '$rootScope', function ($http) {
            return {
                getCalendarData: function (plant_id, year, month) {
                    const url = `/plant/${plant_id}/orders/${year}/${month}/`;
                    return $http.get(url, {});
                },
                getCustomerCalendarData: function (plant_id, year, month) {
                    const url = `/plant/${plant_id}/customer_orders/${year}/${month}/`;
                    return $http.get(url, {});
                },
                quantityList: function (plant_id) {
                    const url = `/plant/${plant_id}/order_date_quantity_list/`;
                    return $http({
                        method: 'GET',
                        url: url,
                        params: {}
                    });
                },
                list: function (plant_id, config) {
                    const url = `/plant/${plant_id}/orders/`;
                    const params = {
                        page_size: config.page_size,
                        page: config.page,
                        sort_by: config.sort_by,
                        sort_order: config.sort_order,
                    };
                    for (let key in config.filters) {
                        if (config.filters.hasOwnProperty(key)) {
                            params[key] = config.filters[key];
                        }
                    }
                    return $http({
                        method: 'GET',
                        url: url,
                        params: params
                    });
                },
                list_tentative: function (plant_id) {
                    const url = `/plant/${plant_id}/tentative_orders/`;
                    return $http({
                        method: 'GET',
                        url: url
                    });
                },
                create: function (order, plant_id) {
                    const url = `/plant/${plant_id}/order/new/`;
                    return $http({
                        method: 'POST',
                        url: url,
                        data: order
                    });
                },
                get: function (order_id, plant_id) {
                    const url = `/plant/${plant_id}/order/${order_id}/`;
                    return $http.get(url, {});
                },
                get_customer_order: function (order_id, plant_id) {
                    const url = `/plant/${plant_id}/customer_order/${order_id}/`;
                    return $http.get(url, {});
                },
                get_order_request: function (order_id, plant_id) {
                    const url = `/plant/${plant_id}/order_request/${order_id}/`;
                    return $http.get(url, {});
                },
                update: function (order, plant_id) {
                    const url = `/plant/${plant_id}/order/${order.id}/`;
                    return $http({
                        method: 'PATCH',
                        url: url,
                        data: order
                    });
                },
                delete: function (order_id, plant_id) {
                    const url = `/plant/${plant_id}/order/${order_id}/delete/`;
                    return $http({
                        method: 'DELETE',
                        url: url
                    });
                }
            };
        }]);
})();
